import { Component, Input, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridService } from '../../../../shared/common-components/ag-grid/ag-grid.service';
import { RangeDatepickerComponent } from '../../../../shared/common-components/range-datepicker/range-datepicker.component';
import { CommonFilterService } from '../../../../shared/services/common-filter.service';
import { StorageService } from '../../../../shared/services/storage.service';

@Component({
  selector: 'app-expense-advanced-filter-popup',
  templateUrl: './advanced-filter-popup.component.html',
  styleUrls: ['./advanced-filter-popup.component.scss']
})
export class ExpenseAdvancedFilterPopupComponent {
  @Input() data: any = {};
  @ViewChildren(RangeDatepickerComponent) dateRangeDatepicker: QueryList<RangeDatepickerComponent>
  selectedAccountLedgerIds = [];
  advanceFilterRequest: any = {}

  constructor(
    public activeModal: NgbActiveModal,
    public renderer: Renderer2,
    public agGridService: AgGridService,
    public storageService: StorageService,
    public commonFilterService: CommonFilterService,
  ) {
  }
  ngAfterViewInit(): void {
    this.setAlreadyAppliedData();
  }
  setAlreadyAppliedData() {
    var previousAppliedFilters = this.storageService.retrieve(this.data?.agGridDataModel?.filterStorageName);
    if (previousAppliedFilters != undefined) {
      this.selectedAccountLedgerIds = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "ledgerid", this.data?.getAllDropdownModel?.accountLedgerDropdown, "multiselectDropdown");
      this.advanceFilterRequest.selectedAccountLedgers = this.selectedAccountLedgerIds?.map((x) => x?.id);
      this.advanceFilterRequest.invoiceNo = this.commonFilterService?.getPreviousAppliedFilter(previousAppliedFilters, "invoiceNo", undefined, "input");
      this.advanceFilterRequest.fromDate = this.commonFilterService?.getPreviousAppliedFilter(previousAppliedFilters, "fromDate", undefined, "input");
      this.advanceFilterRequest.toDate = this.commonFilterService?.getPreviousAppliedFilter(previousAppliedFilters, "toDate", undefined, "input");
      this.advanceFilterRequest.expensesWithTax = this.commonFilterService?.getPreviousAppliedFilter(previousAppliedFilters, "expensesWithTax", undefined, "dropdown");
      this.dateRangeDatepicker?.get(0)?.onApply(false, this.advanceFilterRequest?.fromDate, this.advanceFilterRequest?.toDate);
    }
  }

  onClickAdvancedFilter() {
    this.storageService.removeItem(this.data?.agGridDataModel?.filterStorageName);
    this.commonFilterService.performFilterColumnwise('ledgerid', this.advanceFilterRequest?.selectedAccountLedgers, undefined, this.data?.agGridDataModel?.filterStorageName, '');

    if (this.advanceFilterRequest?.invoiceNo != undefined)
      this.commonFilterService.performFilterColumnwise('invoiceNo', undefined, this.advanceFilterRequest?.invoiceNo, this.data?.agGridDataModel?.filterStorageName, 'textFilter');
    
    if (this.advanceFilterRequest?.expensesWithTax != undefined)
      this.commonFilterService.performFilterColumnwise('expensesWithTax', undefined, this.advanceFilterRequest?.expensesWithTax, this.data?.agGridDataModel?.filterStorageName, 'textFilter');


    if (this.advanceFilterRequest?.fromDate != undefined)
      this.commonFilterService.performFilterColumnwise('fromDate', undefined, this.advanceFilterRequest?.fromDate, this.data?.agGridDataModel?.filterStorageName, 'dateFilter');

    if (this.advanceFilterRequest?.toDate != undefined)
      this.commonFilterService.performFilterColumnwise('toDate', undefined, this.advanceFilterRequest?.toDate, this.data?.agGridDataModel?.filterStorageName, 'dateFilter');

    var filterData = this.commonFilterService.processFilterData(this.data?.agGridDataModel?.filterStorageName)

    this.advanceFilterRequest.filters = filterData;
    this.activeModal.close(this.advanceFilterRequest)
  }

  clearFields() {
    this.advanceFilterRequest = {};
    this.selectedAccountLedgerIds = [];
    this.commonFilterService.setDefaultFilter(this.data?.apiRequestStorageName, this.data?.apiRequestModel, this.data?.agGridDataModel.filterStorageName);
    this.setAlreadyAppliedData();
  }
  
  expensesWithTaxDropdown = [
    { id: true, name: 'True' },
    { id: false, name: 'False' }
  ];
  

}
